import { render, staticRenderFns } from "./FilterCommentsWidget.vue?vue&type=template&id=9e67628e&"
import script from "./FilterCommentsWidget.vue?vue&type=script&lang=ts&"
export * from "./FilterCommentsWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports